import { createContext, useContext } from "react";

export interface CommandPaletteContextValue {
  open: () => void;
  close: () => void;
  isOpen: boolean;
}

export const CommandPaletteContext = createContext<CommandPaletteContextValue>({
  open: () => {},
  close: () => {},
  isOpen: false,
});

export function useCommandPalette() {
  return useContext(CommandPaletteContext);
}
